import React, { Dispatch } from 'react';
import Translator from '../../core/i18n';
import { Log } from 'ng2-logger';
import { IAppState, IAction } from '../../models/action/core';
import { connect } from 'react-redux';
import { Common } from '../../core/common';
import { Redirect } from 'react-router-dom';
import CustomIframe from '../../components/iframe/iframe';
import * as IFrameActions from '../../store/actions/iFrameSource';

const _logger = Log.create('content.tsx');
const T = Translator.create();
const _common = new Common();

export class IframePage extends React.Component<any, any> {
    public state: any = {
    };

    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        const parsedUrl = new URL(window.location.href);
        const sourceUrl = parsedUrl.searchParams.get('sourceUrl');
        const reportFileName = parsedUrl.searchParams.get('fileName');
        if (sourceUrl && !sourceUrl.includes('://')) {
            let model = {
                ReturnUrl: sourceUrl
            }
            if(reportFileName)
            {
                let reportModel = {
                    ReturnUrl: sourceUrl + "/{5}",
                    ReportFileName: reportFileName
                }

                this.props.dispatch(IFrameActions.getIFrameSource(reportModel));

            }
            else{
                this.props.dispatch(IFrameActions.getIFrameSource(model));

            }
        }
    }

    public render() {
        const parsedUrl = new URL(window.location.href);
        const sourceUrl = parsedUrl.searchParams.get('sourceUrl');
        const src = sourceUrl && sourceUrl.includes('://') ? sourceUrl : this.props.iFrameSource
        return (
            <div className="student-course activities-dashboard" style={{ padding: '10px 50px', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                <CustomIframe
                    id='preview'
                    name='preview'
                    width={'99vw'}
                    height={'89vh'}
                    src={src}
                />
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: any) => {
    if (!state) {
        return ownProps;
    }
    const newProps: any = Object.assign({}, ownProps, {
        userPreferences: state.profile.userPreferences.preferences,
        iFrameSource: state.iFrame.iFrameSource
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.iFrame.iFrameSource === prev.iFrame.iFrameSource;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CIframePage = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(IframePage);

export default CIframePage;

